import { render, staticRenderFns } from "./GameEnd.vue?vue&type=template&id=13b26c31&"
import script from "./GameEnd.vue?vue&type=script&lang=ts&"
export * from "./GameEnd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports